export class DescriptionService {
  constructor(httpClient) {
    this.httpClient = httpClient
  }

  async category(params) {
    return await this.httpClient.get('/v01/Categoria/Categoria', { params })
  }

  async subcategory(params) {
    return await this.httpClient.get('/v01/Categoria/SubCategoria', { params })
  }

  async brand(params) {
    return await this.httpClient.get('/v01/Itens/Modelos', { params })
  }

  async veiculo(params) {
    return await this.httpClient.get('/v01/veiculos/Veiculo', { params })
  }
}
